<template>
	<div id="headshot-resume">
		<div class="sectionHeader floater">
			&
		</div>

		<div class="lowerLevel">
			<div class="headshotWrapper">
				<h1 class="sectionHeader wrapperHeader">headshot</h1>


				<div class="headshotFrame" 
					:style="{
						'background-image': 'url(' + headshot.url + ')'
					}">
					<div class="headshotOverlay overlay">
						<a 	:href="headshot.url"
							target="blank"
							download>
							Download Headshot
						</a>
					</div>					
				</div>
			</div>

			<div class="resumeWrapper">
				<div class="resumeFrame" 
                	:style="{
                    	'background-image': 'url(' + resumeScreenshot.url + ')'
                	}">
					<div class="resumeOverlay overlay">
						<a 	:href="resumeFile.url"
							target="blank" 
							download>
							Download Resume
						</a>
					</div>
				</div>

				<h1 class="sectionHeader wrapperHeader">resume</h1>
			</div>
		</div>
	</div>
</template>

<script>

export default{
	name:"Headshot",
	props: ['resumeFile', 'resumeScreenshot', 'headshot', 'headshotScreenshot']
}
</script>

<style scoped lang="scss">
	@import "~@/assets/scss/_variables.scss";

	#headshot-resume{
		height: 90vh;
		border: 20px solid $beigeMint;
		position: relative;

		.sectionHeader{
			background: $nearWhite;
			font-family: 'Montserrat', sans-serif;
			font-size: 3em;
			text-align: center;
			box-sizing: border-box;
		}

		.floater{
			z-index: 3;
			position: absolute;
			left: calc(50% - 25px);
			top: calc(50% - 25px);			
			padding: 10px;
			width: 50px;
			background: $beigePink;
			color: $nearWhite;
		}

		.lowerLevel{
			height: 100%;
			display: grid;
			grid-template-columns: 50% 50%;
			background-color: $beigeMint;

			.headshotWrapper{
				display: grid;
				grid-template-rows: 10% 90%;

				.headshotFrame{
					background-position:center;
					background-repeat:no-repeat;
					background-size:contain;

					width: 100%;
					height: 100%;

					.headshotOverlay{
						position: absolute;
						top: 10%;
						left: 0%;
						height : 90%;
						width: 50%;
						transition: .5s ease;
						opacity: 0;
						background: $beigeMint;
						text-shadow: 2px 2px 2px #000;

						a{
							width: 250px;
							position: absolute;
							color: white;
							background: $beigePink;
							font-family: 'Raleway', 'sans-serif';
							font-size: 2em;
							top: calc(50% - 32px);
							left: calc(50% - 125px);
							text-align: center;
							padding: 10px;
							box-sizing: border-box;
							text-decoration: none;

							&:hover{
								border: 3px solid $darkPurple;
								cursor: default;
							}
						}
					}

					&:hover{
						.headshotOverlay{
							opacity: 0.9;
						}
					}					
				}
			}

			.resumeWrapper{
				display: grid;
				grid-template-rows: 90% 10%;


				.resumeFrame{
					background-position:top;
					background-repeat:no-repeat;
					background-size:contain;

					width: 100%;
					height: 100%;

					.resumeOverlay{
						position: absolute;
						top: 0;
						left: 50%;
						height : 90%;
						width: 50%;
						transition: .5s ease;
						opacity: 0;
						background: $beigeMint;
						text-shadow: 2px 2px 2px #000;

						a{
							width: 250px;
							position: absolute;
							color: white;
							background: $beigePink;
							font-family: 'Raleway', 'sans-serif';
							font-size: 2em;
							top: calc(50% - 32px);
							left: calc(50% - 125px);
							text-align: center;
							padding: 10px;
							box-sizing: border-box;
							text-decoration: none;

							&:hover{
								border: 3px solid $darkPurple;
								cursor: default;
							}
						}
					}

					&:hover{
						.resumeOverlay{
							opacity: 0.9;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: $tabletWidth){
		#headshot-resume{
			height: 90vh;

			.lowerLevel{
				.headshotWrapper{
					.headshotFrame{
						background-size: cover;

						.headshotOverlay{
							opacity: .8;
						}
					}
				}
				.resumeWrapper{
					.resumeFrame{
						background-size: cover;

						.resumeOverlay{
							opacity: .8;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: $largeMobile){
		#headshot-resume{
			height: 100vh;

			.wrapperHeader{
				display: none;
			}

			.floater{
				left: 42%;
				top: 45%;
				width: 15vw;
			}

			.lowerLevel{
				grid-template-rows: 50% 50%;
				grid-template-columns: 100%;

				.overlay{
					height: 50%;
					width: 90%;
					left: 5%;
					top: 0%;
					opacity: .8;
				}

				.headshotWrapper{
					grid-template-rows: 100%;

					.headshotFrame{
						.headshotOverlay{
							height: 50%;
							width: 90%;
							left: 5%;
							top: 0%;
							opacity: .8;
						}
					}
				}

				.resumeWrapper{
					grid-template-rows: 100%;
					.resumeFrame{
						.resumeOverlay{
							height: 50%;
							width: 90%;
							left: 5%;
							top: 50%;
							opacity: .8;
						}
					}
				}
			}
		}
	}
</style>